<template>
  <div id="edit">
    <modal height="auto" classes="msg-modal" width="300px" :adaptive="true" name="message">{{msg}}</modal>
    <el-form ref="form" label-width="80px">
      <el-form-item :label="$t('i18nView.account')">
        <el-input :readonly="true" v-model="account"></el-input>
      </el-form-item>
      <el-form-item class="avatar-wrap" :label="$t('i18nView.avatar')">
        <el-upload
          class="avatar-uploader"
          action="https://webapi.tokenpocket.pro/upload"
          accept="image/*"
          :data="uploadData"
          :show-file-list="false"
          :auto-upload="true"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="avatar" :src="avatar" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-input v-model="avatar"></el-input>
      </el-form-item>
      <el-form-item :label="$t('i18nView.nickname')">
        <el-input v-model="title"></el-input>
      </el-form-item>
      <div class="divider"></div>
      <el-form-item :label="$t('i18nView.intro')"></el-form-item>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2}"
        :placeholder="$t('i18nView.enterIntro')"
        v-model="desc"
      ></el-input>
      <div class="divider"></div>
      <el-form-item :label="$t('i18nView.website')">
        <el-input placeholder="https://www.tokenpocket.pro/" v-model="website"></el-input>
      </el-form-item>
      <el-form-item label="Telegram ID">
        <el-input placeholder="tokenPocket_en" v-model="telegram"></el-input>
      </el-form-item>
      <el-form-item label="Twitter ID">
        <el-input placeholder="TokenPocket_TP" v-model="twitter"></el-input>
      </el-form-item>
      <el-form-item :label="$t('i18nView.wechatId')">
        <el-input placeholder="TP-robot" v-model="wechat"></el-input>
      </el-form-item>
      <div class="divider"></div>
      <el-form-item v-if="!!status" :label="$t('i18nView.lastModifier')">
        <el-input :readonly="true" v-model="modifier"></el-input>
      </el-form-item>
      <!-- <div class="divider"></div> -->
      <!-- <el-form-item v-if="status !== 3" label="花费">
        <el-input :readonly="true" v-model="cost"></el-input>
      </el-form-item>-->

      <div class="divider"></div>
      <el-button
        v-if="status !== 3"
        class="save-btn"
        type="primary"
        @click="onSave"
      >{{$t('i18nView.cost')}} {{cost}} {{$t('i18nView.confirmEdit')}}</el-button>

      <el-button
        @click="onSave"
        class="save-btn"
        type="primary"
        v-else-if="account === currentAccount"
      >{{$t('i18nView.confirmEdit')}}</el-button>
      <el-button v-else class="save-btn" type="primary" disabled>{{$t('i18nView.shortLocked')}}</el-button>
    </el-form>
  </div>
</template>


<script>
import Edit from "./edit";
export default Edit;
</script>


<style lang="less">
#edit {
  max-width: 480px;
  padding: 20px 0;

  .el-textarea {
    padding-bottom: 12px;
    background: #fff;
  }

  .el-form-item__label {
    color: #999;
  }

  .el-form-item {
    margin: 0;
    background-color: #fff;
    padding: 5px 16px;

    .el-input input {
      border: none;
      background: transparent;
      text-align: right;
      padding: 0;

      &:read-only {
        color: #999;
      }
    }
  }

  .avatar-wrap input {
    border-bottom: 1px solid #f1f1f1 !important;
    border-radius: 0;
  }

  .avatar-uploader {
    // line-height: 40px;
  }

  .el-upload {
    padding: 0 0 0 10px;
  }
  .avatar-uploader-icon {
    font-family: iconfont !important;
    color: #666;

    font-size: 20px;

    &:before {
      content: "\e6a2";
    }
  }

  .el-textarea__inner {
    border: none;
    background: #fff;
  }

  .el-form-item__label {
    text-align: left;
    padding: 0;
  }
}
.divider {
  width: 100%;
  padding: 8px 0;
}

.save-btn.el-button {
  display: block;
  width: 80%;
  margin: 0 auto;
}
.avatar-wrap {
  .el-form-item__content {
    line-height: 1;
    text-align: right;
  }
}
.avatar {
  width: 45px;
  height: 45px;
}
</style>
